import { Flex } from "@chakra-ui/layout"

const ShowLiveOverlay = () => {
  return (
    <Flex
      lineHeight="18px"
      width="32px"
      height="18px"
      fontSize="11px"
      fontWeight="medium"
      rounded="4px"
      justifyContent="center"
      alignItems="center"
      color={"white"}
      backgroundColor="#FF0000"
    >
      LIVE
    </Flex>
  )
}

export default ShowLiveOverlay
